<script>
/* eslint-disable no-underscore-dangle */
/* eslint-disable vue/multi-word-component-names */
/**
 * Research Area component.
 *
 * This component contains interaction for the Research area
 * as part of the Web Map sidebar section.
 */
import _ from 'lodash';
import { mapState, mapMutations } from 'vuex';

import {
  ResearchAreaMap,
} from './staticGeom';

import {
  INITIAL_LABELS_MIN_ZOOM,
  INITIAL_LABELS_MAX_ZOOM,
} from '../../utils/constants';

/**
 * @todo Put area thumbnails in constant.js
 */
import AxialBase from '../../assets/img/research-areas/AxialBase-RA.png';
import AxialCaldera from '../../assets/img/research-areas/AxialCaldera-RA.png';
import OregonInshore from '../../assets/img/research-areas/OregonInshore-RA.png';
import OregonOffshore from '../../assets/img/research-areas/OregonOffshore-RA.png';
import OregonShelf from '../../assets/img/research-areas/OregonShelf-RA.png';
import OregonSlopeBase from '../../assets/img/research-areas/OregonSlopeBase-RA.png';
import SouthernHydrateRidge from '../../assets/img/research-areas/SouthernHydrateRidge-RA.png';
import MidPlate from '../../assets/img/research-areas/MidPlate-RA.png';
import WashingtonInshore from '../../assets/img/research-areas/WashingtonInshore-RA.png';
import WashingtonOffshore from '../../assets/img/research-areas/WashingtonOffshore-RA.png';
import WashingtonShelf from '../../assets/img/research-areas/WashingtonShelf-RA.png';

/** Thumbnail for area images next to area label on left sidebar */
const areaThumbnails = {
  AxialBase,
  AxialCaldera,
  OregonInshore,
  OregonOffshore,
  OregonShelf,
  OregonSlopeBase,
  SouthernHydrateRidge,
  MidPlate,
  WashingtonInshore,
  WashingtonOffshore,
  WashingtonShelf,
};

export default {
  name: 'Area',
  props: ['site'],
  data() {
    return {
      isActive: false,
      thumbnailProps: { width: 30, height: 30, class: 'm1' },
    };
  },
  computed: {
    ...mapState({
      map: (state) => state.webmap,
      currentSite: (state) => state.currentSite,
      selectedArea: (state) => state.selectedArea,
    }),
    /**
     * Computed value to get the area thumbnail
     */
    areaThumbnail() {
      const name = this.site.properties.area_name.replace('-', '').replace(/\s/g, '');
      return areaThumbnails[name];
    },
  },
  methods: {
    ...mapMutations(['setSelectedArea']),
    filterSites() {
      const { features } = this.map.getSource('site-areas')._data;
      const site = this.site.properties.reference_designator;
      return _.find(features, ['properties.reference_designator', site]);
    },
    getLayerID(highlightedSite) {
      const initialPoly = this.map.getSource('initial-poly')._data.features;
      const sitePoly = _.find(ResearchAreaMap, ['area_rd', highlightedSite]);
      const selectedPoly = _.find(initialPoly, ['properties.site_key', sitePoly.poly_key]);
      const siteKey = selectedPoly.properties.site_key;
      const layerID = `poly-highlight-${siteKey}`;
      return { layerID, siteKey };
    },
    highlightArea(e) {
      const highlightedSite = this.filterSites(e.currentTarget.id).properties.reference_designator;
      const { layerID, siteKey } = this.getLayerID(highlightedSite);

      this.map.addLayer({
        id: layerID,
        type: 'line',
        source: 'initial-poly',
        minzoom: INITIAL_LABELS_MIN_ZOOM,
        maxzoom: INITIAL_LABELS_MAX_ZOOM,
        layout: {},
        paint: {
          'line-color': 'rgb(250, 0, 255)',
          'line-width': 5,
          'line-blur': 3,
        },
        filter: ['==', 'site_key', siteKey],
      });
    },
    resetArea(e) {
      const highlightedSite = this.filterSites(e.currentTarget.id).properties.reference_designator;
      const { layerID } = this.getLayerID(highlightedSite);
      this.map.removeLayer(layerID);
    },
    zoomToSite(e) {
      const filteredID = e.currentTarget.id.split('/')[2];
      this.$ga('event', 'map_RA_sidebar', { research_area: filteredID });
      const selected = this.filterSites(e.currentTarget.id);
      this.setSelectedArea(selected);
      const coordinates = selected.geometry.coordinates[0];
      const bbox = [coordinates[1], coordinates[3]];
      this.map.fitBounds(bbox, {
        padding: {
          top: 10, bottom: 25, left: 15, right: 5,
        },
        zoom: 11.25,
      });
    },
  },
};
</script>

<template>
  <b-col cols="12" class="sites-card p-0">
    <b-card no-body class="card-item">
      <b-row
        class="highlight site-row"
        :class="{selectedArea: isActive}"
        :id="site.properties.area_url"
        v-on:click="zoomToSite">
        <b-col cols="12" class="p-1 research-area">
          <b-img :src="areaThumbnail"
            v-bind="thumbnailProps"
            rounded="0" class="p-0">
          </b-img>
          <span class="p-2 research-area-text">{{ site.properties.area_name }}</span>
        </b-col>
      </b-row>
    </b-card>
  </b-col>
</template>

<style lang="css" scoped>
.research-area-text {
  font-size: 1.125em; /* 18/16px = 1.125em*/
  padding-right: 1px;
}
.card-item {
  border: none;
  background-color: transparent;
  vertical-align: middle;
}
.research-area {
  cursor: pointer;
  padding: 5px !important;
}
.research-area:hover {
  color: #f2f2f2 !important;
  background-color: #3995a3 !important;
}
</style>
